import Vue from 'vue';
import Router from 'vue-router';

// 应用路由组件
Vue.use(Router);

// 登录
import Login from '@/views/Loginnew/Login.vue';
import Logout from '@/views/Logout/Logout.vue';

// 布局页
import Main from '@/views/Main/Main.vue';
import HomeTH from '@/views/HomeTH/HomeTH.vue';
import HomeLay from '@/views/HomeLay/HomeLay.vue';
import Home from '@/views/Home/Home.vue';
import HomeChare from '@/views/HomeChare/HomeChare.vue';
import HomeSupport from '@/views/HomeSupport/HomeSupport.vue';
import HomeAbout from '@/views/HomeAbout/HomeAbout.vue';
import Products from '@/views/Products/Products.vue';
import AuctionHallList from '@/views/AuctionHall/AuctionHallList/AuctionHallList.vue';
import BidBuyDetail from '@/views/BidBuyDetail/BidBuyDetail.vue';
import BidBuyList from '@/views/BidBuyList/BidBuyList.vue';
import BidBuyNewsList from '@/views/BidBuyNews/BidBuyNewsList.vue';
import BidBuyNewsDetail from '@/views/BidBuyNews/BidBuyNewsDetail.vue';
import EnquiryList from '@/views/EnquiryModule/EnquiryList/EnquiryList.vue';
import EnquiryDetail from '@/views/EnquiryModule/EnquiryDetail/EnquiryDetail.vue';
import EnquiryNoticeDetail from '@/views/EnquiryModule/EnquiryNotice/EnquiryNoticeDetail.vue';
import EnquiryNotice from '@/views/EnquiryModule/EnquiryNotice/EnquiryNotice.vue';
// import EnquiryDetail from '@/views/EnquiryModule/EnquiryDetail/EnquiryDetail.vue';
import AuctionHallDetail from '@/views/AuctionHall/AuctionHallDetail/AuctionHallDetail.vue';
import AuctionDownload from '@/views/AuctionHall/AuctionDownload/AuctionDownload.vue';
import News from '@/views/AuctionHall/News/News.vue';
import SupportAndService from '@/views/SupportAndService/SupportAndService.vue';
import ContactUs from '@/views/ContactUs/ContactUs.vue';
import Detail from '@/views/Detail/Detail.vue';
import Detail2 from '@/views/Detail/Detail2.vue';
import Charge from '@/views/Charge/Charge.vue';
import Pay from '@/views/Charge/Pay.vue';
import Layout from '@/views/Layout/Layout.vue';
import MeLayout from '@/views/Me/LayOutTH/LayOutTH.vue';
import Close from '@/views/Layout/Close.vue';
import Order from '@/views/Order/Order.vue';
import PayOrder from '@/views/PayOrder/PayOrderTH.vue';
// Me
import userInfo from '@/views/Me/userInfo/userInfo.vue';
import myMember from '@/views/Me/myMember/myMember.vue';
import BankCard from '@/views/Me/BankCard/BankCard.vue';
import Cars from '@/views/Me/Cars/Cars.vue';
import HazardousChemicalsEntry from '@/views/Me/HazardousChemicalsEntry/HazardousChemicalsEntry.vue';
import TransportationCompany from '@/views/Me/HazardousChemicalsEntry/TransportationCompany/TransportationCompany.vue';
import Trailer from '@/views/Me/HazardousChemicalsEntry/Trailer/Trailer.vue';
import Tractor from '@/views/Me/HazardousChemicalsEntry/Tractor/Tractor.vue';
import Driver from '@/views/Me/HazardousChemicalsEntry/Driver/Driver.vue';
import Escort from '@/views/Me/HazardousChemicalsEntry/Escort/Escort.vue';
import Set from '@/views/Me/Info/Set.vue';
import OrderList from '@/views/Me/OrderList/OrderList.vue';
import OrderDetail from '@/views/Me/OrderDetail/OrderDetail.vue';
import OrderLading from '@/views/Me/OrderLading/OrderLading.vue';
import MyBidding from '@/views/Me/MyBidding/MyBidding.vue';
//注册
import RegisterTH from '@/views/RegisterTH/RegisterTH.vue';
import LoginTH from '@/views/LoginTH/LoginTH.vue';



// 充值

import Password from '@/views/Password/Password.vue';
// 企业认证
import Company from '@/views/Me/Company/Company.vue';
//Todo
import CompanyList from '@/views/Me/CompanyList/CompanyList.vue';
import CompanyAuthen from '@/views/Me/CompanyAuthen/CompanyAuthen.vue';
import SupplierCertification from '@/views/Me/SupplierCertification/SupplierCertification.vue';
import companyFinished from '@/views/Me/companyFinished/companyFinished.vue';
import CompanyQualificationsInfo from '@/views/Me/CompanyQualificationsInfo/CompanyQualificationsInfo.vue';
import EgQualifications from '@/views/Me/EgQualifications/EgQualifications.vue';


var router = new Router({
  mode: 'history',
  routes: [
    { name: 'Logout', path: '/Logout', component: Logout },
    { name: 'RegisterTH', path: '/RegisterTH', component: RegisterTH },
    { name: 'LoginTH', path: '/LoginTH', component: LoginTH },
    {
      path: '/',
      component: HomeTH,
      redirect: '/',
      children: [
        { name: 'Home', path: '/', component: Home, meta: { name: '首页', isHome: true } },
        { name: 'HomeChare', path: 'HomeChare', component: HomeChare, meta: { name: '交易大厅', } },
        { name: 'HomeSupport', path: 'HomeSupport', component: HomeSupport, meta: { name: '支持与服务', } },
        { name: 'HomeAbout', path: 'HomeAbout', component: HomeAbout, meta: { name: '关于我们', } },
      ],
      meta: { name: '首页' }
    },
    {
      path: '/Menu',
      component: HomeLay,
      redirect: '/',
      children: [
        { name: 'Products', path: 'Products', component: Products, meta: { name: '产品中心', } },
        { name: 'AuctionHallList', path: 'AuctionHallList', component: AuctionHallList, meta: { name: '招标大厅', } },
        { name: 'BidBuyList', path: 'BidBuyList', component: BidBuyList, meta: { name: '竞采大厅', } },
        { name: 'BidBuyNewsList', path: 'BidBuyNewsList', component: BidBuyNewsList, meta: { name: '竞采公告', } },
        { name: 'BidBuyNewsDetail', path: 'BidBuyNewsDetail', component: BidBuyNewsDetail, meta: { name: '竞采公告详情', } },
        { name: 'BidBuyDetail', path: 'BidBuyDetail', component: BidBuyDetail, meta: { name: '竞采详情', } },
        { name: 'AuctionHallDetail', path: 'AuctionHallDetail', component: AuctionHallDetail, meta: { name: '招标详情', } },
        { name: 'AuctionDownload', path: 'AuctionDownload', component: AuctionDownload, meta: { name: '公告详情', } },
        { name: 'News', path: 'News', component: News, meta: { name: '公告', } },
        { name: 'SupportAndService', path: 'SupportAndService', component: SupportAndService, meta: { name: '支持与服务', } },
        { name: 'ContactUs', path: 'ContactUs', component: ContactUs, meta: { name: '联系我们', } },
        { name: 'Detail', path: 'Detail', component: Detail, meta: { name: '产品详情', canBack: true },  props: (route) => ({ id: route.query.id, w: route.query.w,y: route.query.y }) },
        { name: 'Detail2', path: 'Detail2', component: Detail2, meta: { name: '产品详情', canBack: true },  props: (route) => ({ id: route.query.id, w: route.query.w,y: route.query.y }) },
        { name: 'Order', path: 'Order', component: Order, meta: { name: '创建订单' } ,  props: (route) => ({ id: route.query.id, num: parseInt(route.query.num) })},
        { name: 'PayOrder', path: 'PayOrder', component: PayOrder, meta: { name: '创建订单' } ,  props: (route) => ({ id: route.query.id, num: parseInt(route.query.num) })},
        { name: 'Charge', path: 'Charge', component: Charge, meta: { name: '创建订单' } },
        { name: 'Pay', path: 'Pay', component: Pay, meta: { name:'支付页面', canBack: true } },
        { name: 'EnquiryList', path: 'EnquiryList', component: EnquiryList, meta: { name: '询价大厅', } },
        { name: 'EnquiryDetail', path: 'EnquiryDetail', component: EnquiryDetail, meta: { name: '询价详情', } },
        { name: 'EnquiryNotice', path: 'EnquiryNotice', component: EnquiryNotice, meta: { name: '询价公告', } },
        { name: 'EnquiryNoticeDetail', path: 'EnquiryNoticeDetail', component: EnquiryNoticeDetail, meta: { name: '公告详情', } },
      ],
      meta: { name: '首页' }
    },
    {
      path: "/My",
      redirect: '/',
      component: MeLayout,
      children: [
        { name: 'userInfo', path: 'userInfo', component: userInfo, meta: { name: '会员中心', isMe: true  } },
        { name: 'myMember', path: 'myMember', component: myMember, meta: { name: '我的会员', isMe: true  } },
        { name: 'OrderList', path: 'OrderList', component: OrderList, meta: { name: '我的订单', isMe: true  } },
        // { name: 'MyYYOrder', path: 'MyYYOrder', component: MyYYOrder, meta: { name: '我的预约订单', isMe: true  } },
        { name: 'OrderLading', path: 'OrderLading', component: OrderLading, meta: { name: '我的提货单', isMe: true  } },
        // { name: 'TransferOrderList', path: 'TransferOrderList', component: TransferOrderList, meta: { name: '调拨订单', isMe: true  } },

        // { name: 'Assets', path: 'Assets', component: Assets, meta: { name: '我的资产', isMe: true  } },
        // { name: 'Cash', path: 'Cash', component: Cash, meta: { name:'提现申请', canBack: true, isMe: true }},
        // { name: 'Cars', path: 'Cars', component: Cars, meta: { name: '车辆管理', isMe: true  } },
        // { name: 'MoneyDetail', path: 'MoneyDetail', component: MoneyDetail, meta: { name: '资产明细', isMe: true  } },
        // { name: 'MessageList', path: 'MessageList', component: MessageList, meta: { name: '消息详情', isMe: true  } },
        // { name: 'RechargeHistory', path: 'RechargeHistory', component: RechargeHistory, meta: { name: '充值记录', isMe: true  } },
        // { name: 'Company', path: 'Company', component: Company, meta: { name: '企业认证', isMe: true  } },
        { name: 'CompanyList', path: 'CompanyList', component: CompanyList, meta: { name: '企业认证列表', isMe: true  } },
        { name: 'CompanyAuthen', path: 'CompanyAuthen', component: CompanyAuthen, meta: { name: '企业认证', isMe: true  } },
        { name: 'SupplierCertification', path: 'SupplierCertification', component: SupplierCertification, meta: { name: '供应商认证', isMe: true  } },
        { name: 'companyFinished', path: 'companyFinished', component: companyFinished, meta: { name: '企业认证完成', isMe: true  } },
        { name: 'CompanyQualificationsInfo', path: 'CompanyQualificationsInfo', component: CompanyQualificationsInfo, meta: { name: '企业认证资质', isMe: true  },props: (route) => ({ iscom:route.query.iscom })  },
        { name: 'EgQualifications', path: 'EgQualifications', component: EgQualifications, meta: { name: '易购认证', isMe: true  },props: (route) => ({ iscom:route.query.iscom }) },
        { name: 'OrderDetail', path: 'OrderDetail', component: OrderDetail, meta: { name: '订单详情', isMe: true  },   props: (route) => ({ id: route.query.id })},
        // { name: 'UserInfo', path: 'UserInfo', component: UserInfo, meta: { name: '联系人信息', isMe: true  } },
        { name: 'Set', path: 'Set', component: Set, meta: { name: '个人中心', isMe: true  } },
        // { name: 'Authentication', path: 'Authentication', component: Authentication, meta: { name: '认证与资质', isMe: true  } },
        // { name: 'PerfectInformation', path: 'PerfectInformation', component: PerfectInformation, meta: { name: '完善信息', isMe: true  } },
        // { name: 'CashList', path: 'CashList', component: CashList, meta: { name:'提现记录', canBack: true, isMe: true }},
        // { name: 'CustomerQty', path: 'CustomerQty', component: CustomerQty, meta: { name: '客存查询', isMe: true  } },
        // { name: 'BillOrderList', path: 'BillOrderList', component: BillOrderList, meta: { name: '提货订单', isMe: true  } },
        // { name: 'LadingList', path: 'LadingList', component: LadingList, meta: { name: '提货单', isMe: true  } },
        // { name: 'OrderCustomerDetail', path: 'OrderCustomerDetail', component: OrderCustomerDetail, meta: { name: '订单详情', isMe: true  },   props: (route) => ({ id: route.query.id })},
        // { name: 'SubAccount', path: 'SubAccount', component: SubAccount, meta: { name: '子账号管理', isMe: true  } },
        // { name: 'SapBalance', path: 'SapBalance', component: SapBalance, meta: { name: 'SAP余额查询', isMe: true  } },
        // { name: 'RemoteRepositoryBalance', path: 'RemoteRepositoryBalance', component: RemoteRepositoryBalance, meta: { name: '异地库余额查询', isMe: true  } },
        { name: 'BankCard', path: 'BankCard', component: BankCard, meta: { name: '银行卡管理', isMe: true  } },
        { name: 'Cars', path: 'Cars', component: Cars, meta: { name: '车辆管理', isMe: true  } },
        { name: 'HazardousChemicalsEntry', path: 'HazardousChemicalsEntry', component: HazardousChemicalsEntry, meta: { name: '危化品录入', isMe: true  } },
        { name: 'TransportationCompany', path: 'TransportationCompany', component: TransportationCompany, meta: { name: '运输单位', isMe: true  } },
        { name: 'Trailer', path: 'Trailer', component: Trailer, meta: { name: '挂车', isMe: true  } },
        { name: 'Tractor', path: 'Tractor', component: Tractor, meta: { name: '牵引车', isMe: true  } },
        { name: 'Driver', path: 'Driver', component: Driver, meta: { name: '司机', isMe: true  } },
        { name: 'Escort', path: 'Escort', component: Escort, meta: { name: '押运员', isMe: true  } },
        // { name: 'PaymentPasswordSettings', path: 'PaymentPasswordSettings', component: PaymentPasswordSettings, meta: { name: '支付密码设置', isMe: true  } },
        // { name: 'CxConstract', path: 'CxConstract', component: CxConstract, meta: { name: '长协合同', isMe: true  } },
        // { name: 'SalesCompanyOrder', path: 'SalesCompanyOrder', component: SalesCompanyOrder, meta: { name: '销售公司订单', isMe: true  } },
        { name: 'MyBidding', path: 'MyBidding', component: MyBidding, meta: { name: '我参与的招标', isMe: true  } },

      ],
      meta: { name: '我' }
    },
    {
      path: "/Forgot",
      redirect: '/',
      component: Main,
      children: [
        { name: 'Password', path: 'Password', component: Password, meta: { name: '找回密码', isLogin: true } },
      ],
      meta: { name: '找回' }
    },
    {
      name: 'Close',
      path: "/Close",
      component: Close
    }
  ]
});
// beforeEach 全局钩子
router.beforeEach(function (to, from, next) {
  // var isOrder = /^\/Order.*$/g;
  // var isOrderBill = /^\/OrderBill.*$/g;
  //
  // var token = localStorage.ms_token;
  var expires = localStorage.ms_token_expires;
  var now = (new Date()).getTime();
  next();
  //跳转控制
  console.log(to)
  // if (to.path === '/loginTH' || to.path === '/') {
  //   next()
  // } else {
  //   next({ path: '/loginTH' })
  // }
  // if (now > expires) {
  //   //登陆超时,跳回登陆页
  //   localStorage.removeItem('ms_isLogin');
  //   if (to.path === '/loginTH' || to.path === '/') {
  //     next()
  //   } else {
  //     next({ path: '/loginTH' })
  //   }
  // } else {
  //   //正常跳转至目标地址
  //   next();
  // }
});

// 定义路由
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js